/**
 * @voltxampere/web — i18n runtime (Sprint 11).
 *
 * Single `t(key, params?)` lookup, reactive on `currentLocale`.
 * Sprint 18 will expand to ~200 keys + plural rules; Sprint 11
 * just needs the shell strings.
 *
 * Template syntax: `{name}` placeholders, replaced by string
 * values from the `params` record. Missing values stay as the
 * literal placeholder so it is visible during dev.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { currentLocale } from "../store/locale.js";
import { tr, type TranslationKey } from "./tr.js";
import { en } from "./en.js";

const bundles: Readonly<Record<"tr" | "en", Readonly<Record<TranslationKey, string>>>> = {
  tr,
  en,
};

export type { TranslationKey };

/**
 * Resolve a translation key against the current locale.
 *
 * @param key The translation key (compile-time-checked union).
 * @param params Optional `{name}` template substitutions.
 */
export function t(key: TranslationKey, params?: Readonly<Record<string, string>>): string {
  const bundle = bundles[currentLocale.value];
  let str: string = bundle[key];
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      str = str.replaceAll(`{${k}}`, v);
    }
  }
  return str;
}
